	// @flow
	
	import { NavigateBefore } from "@mui/icons-material";
	import CheckIcon from "@mui/icons-material/Check";
	import ClearIcon from "@mui/icons-material/Clear";
	import DeleteIcon from "@mui/icons-material/Delete";
	import EditIcon from "@mui/icons-material/Edit";
	import SaveIcon from "@mui/icons-material/Save";
	import LoadingButton from "@mui/lab/LoadingButton";
	import { Button, FormControl, FormHelperText, FormLabel } from "@mui/material";
	import Box from "@mui/material/Box";
	import Grid from "@mui/material/Grid2";
	import IconButton from "@mui/material/IconButton";
	import Tooltip from "@mui/material/Tooltip";
	import { GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GridActionsCellItem, GridEditInputCell } from "@mui/x-data-grid-premium";
	import { DatePicker } from "@mui/x-date-pickers-pro";
	import { uuid } from "@tinymce/tinymce-react/lib/es2015/main/ts/Utils";
	import axios from "axios";
	import dayjs from "dayjs";
	import { ErrorMessage, FormikProvider } from "formik";
	import { enqueueSnackbar } from "notistack";
	import React, { useCallback, useEffect, useMemo, useState } from "react";
	import { useTranslation } from "react-i18next";
	import { Link } from "react-router-dom";
	import Delete from "../../../components/app/delete/delete";
	import PageMenu from "../../../components/custom/app/pageMenu/pageMenu";
	import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
	import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
	import CustomAutocomplete from "../../../components/mui/form/autocomplete/autocomplete";
	import Modal from "../../../components/mui/general/modal/modal";
	import EditableMUICellValidation
		from "../../../components/mui/grids/editableMUICellValidation/editableMUICellValidation";
	import EditableMUIDataGridAsField
		from "../../../components/mui/grids/editableMUIDataGridAsField/editableMUIDataGridAsField";
	import EditableMuiDataGridCustomFields
		from "../../../components/mui/grids/editableMUIDataGridCustomFields/editableMUIDataGridCustomFields";
	import { API } from "../../../helpers/constants";
	import { handleAxiosErrors } from "../../../helpers/errorHandling";
	import { muiGridLocales } from "../../../helpers/muiGridLocales";
	import { access_registrations, access_user } from "../../../helpers/rights";
	import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
	import { formControlDefaults } from "../../../helpers/theme/defaultProps";
	import useUserData from "../../../hooks/user/useUserData";
	import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
	import { ROUTE_PAGE_PROJECT_DETAILS, ROUTE_PAGE_PROJECT_EDIT } from "../../projects/routes/routes";
	import useRegistrationForm, { isUUID } from "../hooks/useRegistrationForm";
	import { REGISTRATIONS } from "../locales/namespaces";
	import WorkersGridField from "./workersGridField";
	
	type Props = {};
	
	//EditableMuiDataGridAsField
	const newRowModel = {
		UserId: '',
		WorkTm: '',
		ExtraWorkTm: '',
		rowStored: false
	}
	
	const Form = (props: Props) => {
		const { registrationId, registration, projects, users, workers, projectWorks } = props
		const { t } = useTranslation(REGISTRATIONS)
		const { dateFormat, token, language } = useUserData();
		const { formik, loadingSubmit, onSubmit } = useRegistrationForm({
			registrationId,
			registration,
			projects,
			users,
			workers,
			projectWorks
		})
		const [loadingSearch, setLoadingSearch] = useState(false)
		const [projectsData, setProjectsData] = useState(Array.isArray(projects) ? projects : [])
		const [usersData, setUsersData] = useState(Array.isArray(users) ? users : [])
		
		const handleSearch = (evt, name) => {
			let url
			let setter
			let foreman
			switch (name) {
				case 'projectsData':
					url = `${API}/en/fts/project/search`
					setter = setProjectsData
					foreman = 0
					break
				case 'usersData':
					url = `${API}/en/fts/project/user/search`
					setter = setUsersData
					foreman = 1
					break
				default:
					break
			}
			setLoadingSearch(true)
			axios({
				method: 'post',
				data: { 'query': evt.target.value, isForeman: foreman },
				url: url,
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			}).then((response) => {
				if (response.data.result.length > 0) {
					setter(response.data.result)
				}
				setLoadingSearch(false)
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
				setLoadingSearch(false)
			})
		}
		
		const getRestrictions = useCallback((users, workDate = null) => {
			const checkDate = workDate ? workDate : formik.values.WorkDt
			if (checkDate && checkDate?.isValid() && users && users.length > 0) {
				const formattedDate = dayjs(checkDate).format('YYYY-MM-DD')
				axios({
					method: 'post',
					data: { 'users': users, WorkDt: formattedDate },
					url: `${API}/en/fts/project/work/hours`,
					headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				}).then((response) => {
					const data = response.data.totals
					if (data && data.length > 0) {
						formik.setFieldValue('restrictions', data.map(i => ({
							workTm: Number(i.WorkTm),
							extraWorkTm: Number(i.ExtraWorkTm),
							totalTm: Number(i.Total),
							userId: i.UserId
						})))
					} else {
						formik.setFieldValue('restrictions', [])
					}
				}).catch((error) => {
					enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
						variant: 'warning',
						autoHideDuration: 3000,
					})
				})
			}
		}, [t, formik])
		
		const handleDate = (newValue, name) => {
			const users = formik.values.projectWorks.map((i) => (i.UserId?.id))?.filter(f => f)
			getRestrictions(users, newValue)
			formik.setFieldValue(name, newValue);
		};
		
		// delete button
		const [isDeletionVisible, setIsDeletionVisible] = useState(false)
		const handleDeletionModal = (visible) => {
			setIsDeletionVisible(visible)
		}
		
		const columns = useMemo(() => {
			const handleRowDelete = (id) => {
				// η γραμμή που διαγράφουμε
				const deletedRow = formik.values.projectWorks?.find((row) => row.id === id);
				//ενημερώνουμε το ui να σβήσει (εμφανισιακά τη γραμμή)
				const updatedRows = formik.values.projectWorks?.filter((row) => row.id !== id)
				formik.setFieldValue('projectWorks', updatedRows)
	
				if(!isUUID(id)){ //εαν η εγγραφή έχει κανονικό id (είναι αποθηκευμένη)
					axios({ //κάνε κλήση, σβήσ' την από τη βάση
						method: 'post',
						data: {
							WorkId: id
						},
						headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
						url: `${API}/en/fts/project/work/remove`
					}).then(response => {
						console.log(response)
						const updatedRows = formik.values.projectWorks?.filter((row) => row.id !== id)
						formik.setFieldValue('projectWorks', updatedRows) // και αφού πετύχει ανανέωσε το formik
						
						enqueueSnackbar(t(`Work remove successfully!`), {
							variant: 'success',
							autoHideDuration: 3000,
						});
						const users = updatedRows.map(r => r.UserId?.id).filter(Boolean)
						getRestrictions(users)
					}).catch((error) => {
						const message = error?.response?.data?.message
						
						// Αν αποτύχει η διαγραφή, επαναφέρουμε τη διαγεγραμμένη γραμμή, με μια μικρή καθυστέρηση, γιατί διαφορετικά τον εμφανίζει για πολυ μικρο χρονικό διάστημα και τον ξανά εξαφανίζει.
						setTimeout(() => {
							const rollbackRows = [...formik.values.projectWorks, deletedRow];
							formik.setFieldValue('projectWorks', rollbackRows);
						}, 1500);
					
						
						enqueueSnackbar(handleAxiosErrors(error, t(message)), {
							variant: 'warning',
							autoHideDuration: 3000,
						})
					})
				}
			}
			return [
				{
					field: 'actions',
					headerName: t('Actions'),
					width: 80,
					type: 'actions',
					getActions: (params) => {
						const rowStored = params.row.rowStored
						return [
							<GridActionsCellItem
								// onClick={() => console.log(params.id)}
								onClick={() => handleRowDelete(params.id)}
								icon={<DeleteIcon/>}
								label={t('Delete')}
								color={'error'}
								tabIndex={-1}
							/>,
							...(rowStored ? [
								<GridActionsCellItem
									icon={<CheckIcon/>}
									color={'success'}
									label={t('Row Saved')}
									sx={{ pointerEvents: 'none' }}
									tabIndex={-1}
								/>
							] : []),
						]
					},
				},
				{
					field: 'UserId',
					headerName: t('Worker'),
					minWidth: 300,
					flex: 1,
					editable: true,
					preProcessEditCellProps: (params) => {
						const value = params.props.value
						if ((typeof value === 'string' && !value) || (typeof value !== 'string' && !value?.id)) {
							return { ...params.props, error: t('Required') };
						}
						return { ...params.props, error: null }; // No error
					},
					renderCell: params => {
						const userName = params.row.UserId?.Description ? params.row.UserId?.Description : ''
						return <Box>{userName}</Box>
					},
					renderEditCell: (params) => {
						return (
							<WorkersGridField
								params={params}
								getRestrictions={getRestrictions}
								formik={formik}
								workers={workers}
							/>
						);
					}
				},
				{
					field: 'WorkTm',
					headerName: t('Work Time'),
					minWidth: 90,
					flex: 1,
					editable: true,
					type: 'number',
					valueGetter: (value, row, column, apiRef) => value ? Number(value).toFixed(2) : '',
					// aggregationMethod: (values) => (values).reduce((sum, current) => sum + current, 0),
					preProcessEditCellProps: (params) => {
						const inputValue = params.props.value;
						const num = Number(inputValue);
						const extraWorkNum = Number(params.otherFieldsProps?.ExtraWorkTm?.value); //τιμή πεδίου extraWorkTm για τη σύγκριση total
						const selectedUser = params.otherFieldsProps.UserId?.value?.id;
						const lineRestrictions = formik.values.restrictions.find(f => f.userId === selectedUser)
						const workTm = lineRestrictions?.workTm ? lineRestrictions.workTm : 0
						const totalTm = lineRestrictions?.totalTm ? lineRestrictions.totalTm : 0
						const isValid = !isNaN(num) && (num * 10) % 5 === 0; //έλεγχος για να παίρνει μόνο τα μισά. π.χ. 0,5 / 1,5
						const isWorkTmValid = !isNaN(num) && (num + workTm) <= 7; //κανόνας: η τιμή που παίρνει το workTm καί όσες ώρες έχουν συμπληρώσει ακόμα για αυτον τον εργάτη να μην ξεπερνούν τις 7 ώρες
						const isTotalTmValid = !isNaN(num) && (num + extraWorkNum + totalTm) <= 24; //οι συνολικές ώρες του εργάτη να μην ξεπερνούν τις 24
						if (inputValue === '') {
							return { ...params.props, error: t('Required') };
						} else if (!isValid) {
							return {
								...params.props,
								error: t('Only numbers in 0.5 increments are allowed (e.g. 1, 1.5, 2)'),
							};
						} else if (!isWorkTmValid) {
							return {
								...params.props,
								error: t('workTimeMessage', { workTm: workTm }),
							};
						} else if (!isTotalTmValid) {
							
							return {
								...params.props,
								error: t('extraWorkMessage', { extraWorkTm: totalTm + extraWorkNum }),
							};
						}
						
						return { ...params.props, error: null };
						
					},
					renderEditCell: (params) => {
						return (
							<EditableMUICellValidation {...params}>
								<Box>
									<EditableMuiDataGridCustomFields
										type={'number'}
										params={params}
										name={'WorkTm'}
										onChange={({ newValue, apiRef, params }) => {
											// console.log(newValue,params,params.row.UserId?.id);
											// για validation ωρών του εργαζόμενου κάθε φορά που αλλάζει τιμή
											if (params.row.UserId?.id) {
												const existingUsers = formik.values.projectWorks.map((i) => (i.UserId?.id))?.filter(f => f)
												getRestrictions([...existingUsers, params.row.UserId?.id])
											}
										}}
									/>
								</Box>
							</EditableMUICellValidation>
						)
					},
				},
				{
					field: 'ExtraWorkTm',
					headerName: t('Extra Work Time'),
					minWidth: 90,
					flex: 1,
					editable: true,
					type: 'number',
					valueGetter: (value, row, column, apiRef) => value ? Number(value).toFixed(2) : '',
					// aggregationMethod: (values) => (values).reduce((sum, current) => sum + current, 0),
					preProcessEditCellProps: (params) => {
						const inputValue = params.props.value;
						const num = Number(inputValue);
						const workNum = Number(params.otherFieldsProps?.WorkTm?.value);
						const isValid = !isNaN(num) && (num * 10) % 5 === 0;
						const selectedUser = params.otherFieldsProps.UserId?.value?.id;
						const lineRestrictions = formik.values.restrictions.find(f => f.userId === selectedUser)
						const totalTm = lineRestrictions?.totalTm ? lineRestrictions.totalTm : 0
						const isTotalTmValid = !isNaN(num) && (num + workNum + totalTm) <= 24;
						if (inputValue === '') {
							return { ...params.props, error: t('Required') };
						} else if (!isValid) {
							return {
								...params.props,
								error: t('Only numbers in 0.5 increments are allowed (e.g. 1, 1.5, 2)'),
							};
						} else if (!isTotalTmValid) {
							return {
								...params.props,
								error: t('extraWorkMessage', { extraWorkTm: totalTm + workNum }),
							};
						}
						
						return { ...params.props, error: null };
					},
					renderEditCell: (params) => {
						return (
							<EditableMUICellValidation {...params}>
								<Box>
									<EditableMuiDataGridCustomFields
										type={'number'}
										params={params}
										name={'ExtraWorkTm'}
										onChange={({ newValue, apiRef, params }) => {
											// console.log(newValue,params,params.row.UserId?.id);
											// για validation ωρών του εργαζόμενου κάθε φορά που αλλάζει τιμή
											if (params.row.UserId?.id) {
												const existingUsers = formik.values.projectWorks.map((i) => (i.UserId?.id))?.filter(f => f)
												getRestrictions([...existingUsers, params.row.UserId?.id])
											}
										}}
									/>
								</Box>
							</EditableMUICellValidation>
						)
					},
				},
			]
		}, [t, formik, getRestrictions, workers])
		
		// TODO::disable fields if registrationId is present or if first row is stored
		const disableFields = useMemo(() => (Boolean(registrationId) || formik.values.firstRowAdded), [registrationId, formik.values.firstRowAdded])
		
		return (
			<FormikProvider value={formik}>
				<form
					autoComplete="off"
					id="registrationForm"
					encType="multipart/form-data"
					style={{ marginTop: '10px' }}
				>
					<Box display={'flex'}
						 flexWrap={'wrap'}
						 justifyContent={'space-between'}
						 gap={1}>
						<PageMenu>
							<Button
								component={Link}
								startIcon={<NavigateBefore/>}
								to={`/registrations`}
							>
								{t('Return')}
							</Button>
							{/*<LoadingButton*/}
							{/*	loading={loadingSubmit}*/}
							{/*	onClick={formik.submitForm}*/}
							{/*	variant="contained"*/}
							{/*	startIcon={<SaveIcon/>}*/}
							{/*>*/}
							{/*	{t('Save')}*/}
							{/*</LoadingButton>*/}
						</PageMenu>
						{registrationId &&
							<Button
								size={'small'}
								variant={'contained'}
								color={'error'}
								onClick={() => handleDeletionModal(true)}
							>
								{t('Delete')}
							</Button>
						}
					</Box>
					<PageContentWrapper>
						<PageTitle
							withDivider
							title={!registrationId ? t('Registration Create') : t('Registration Edit')}
						/>
						<Grid
							container
							spacing={2}
							sx={{ marginLeft: '0px' }}
						>
							<Grid size={{ xs: 12, sm: 6, md: 4 }}>
								<FormControl
									{...formControlDefaults}
									error={
										formik.touched['ProjectId'] &&
										Boolean(formik.errors['ProjectId'])
									}
								>
									<FormLabel required>{t('Project')}</FormLabel>
									<CustomAutocomplete
										identifier={'id'}
										value={formik.values.ProjectId}
										onChange={(evt, newValue) => {
											formik.setFieldValue('ProjectId', newValue);
										}}
										onBlur={formik.handleBlur}
										options={projectsData}
										labelKey={'Description'}
										onInputChange={(event) => handleSearch(event, 'projectsData')}
										otherprops={{
											handleHomeEndKeys: true
										}}
										disabled={disableFields}
									/>
									<FormHelperText>
										<ErrorMessage name={'ProjectId'}/>
									</FormHelperText>
								</FormControl>
							</Grid>
							<Grid size={{ xs: 12, sm: 6, md: 4 }}>
								<FormControl
									{...formControlDefaults}
									error={
										formik.touched['UserId'] &&
										Boolean(formik.errors['UserId'])
									}
								>
									<FormLabel required>{t('Foreman')}</FormLabel>
									<CustomAutocomplete
										identifier={'id'}
										value={formik.values.UserId}
										onBlur={formik.handleBlur}
										onChange={(evt, newValue) => formik.setFieldValue('UserId', newValue)}
										options={usersData}
										labelKey={'Description'}
										onInputChange={(event) => handleSearch(event, 'usersData')}
										otherprops={{
											handleHomeEndKeys: true
										}}
										disabled={disableFields}
									/>
									<FormHelperText>
										<ErrorMessage name={'UserId'}/>
									</FormHelperText>
								</FormControl>
							</Grid>
							<Grid size={{ xs: 12, sm: 6, md: 4 }}>
								<FormControl
									{...formControlDefaults}
									error={
										formik.touched['WorkDt'] &&
										Boolean(formik.errors['WorkDt'])
									}
								>
									<FormLabel required>{t('WorkDt')}</FormLabel>
									<DatePicker
										slotProps={{
											textField: {
												size: 'small',
												variant: 'standard'
											}
										}}
										name="WorkDt"
										views={['year', 'month', 'day']}
										inputFormat={'DD-MM-YYYY'}
										value={formik.values.WorkDt}
										onChange={(newValue) => handleDate(newValue, 'WorkDt')}
										onBlur={formik.handleBlur}
										format={dateFormat}
										disabled={disableFields}
									/>
									<FormHelperText>
										<ErrorMessage name={'WorkDt'}/>
									</FormHelperText>
								</FormControl>
							</Grid>
						</Grid>
						<Box>
							<Box sx={{ minWidth: 500, minHeight: 500 }}>
								<FormControl
									{...formControlDefaults}
								>
									<EditableMUIDataGridAsField
										formik={formik}
										newRowModel={newRowModel}
										fieldName={'projectWorks'}
										columns={columns}
										rowIdentifier={'id'}
										dataGridOtherProps={{
											localeText: muiGridLocales(language)
										}}
										onRowUpdate={(updatedRow, originalRow, fieldName, apiRef, updatedRows) => {
											onSubmit({
												...formik.values,
												projectWorks: [...updatedRows],
												newLine: isUUID(updatedRow.id)
											}, updatedRow)

											// setTimeout(() => {
											// 	apiRef.current.startRowEditMode()
											// }, 50);
											// apiRef.current.setRowChildrenExpansion()
											// console.log(apiRef.current,apiRef.current.getRowMode())
										}}
					
										validateFormBeforeAddingRow={true}
									/>
									<FormHelperText>
										<ErrorMessage name={'projectWorks'}/>
									</FormHelperText>
								</FormControl>
								<Box
									mt={2}
									p={2}
									display="flex"
									justifyContent="flex-end"
									gap={4}
									borderRadius="0 0 8px 8px"
								>
									<Box>
										<strong>{t('Work Time')}:</strong>{" "}
										{formik.values.projectWorks.reduce((acc, row) => acc + (Number(row.WorkTm) || 0), 0).toFixed(2)}
									</Box>
									<Box>
										<strong>{t('Extra Work Time')}:</strong>{" "}
										{formik.values.projectWorks.reduce((acc, row) => acc + (Number(row.ExtraWorkTm) || 0), 0).toFixed(2)}
									</Box>
								</Box>
							</Box>
							<Modal
								show={isDeletionVisible}
							>
								<Delete
									objectId={registrationId}
									objectLabel={t('Description')}
									objectLabelValue={registration.Description}
									deletionUrl={`${API}/en/fts/project/work/remove`}
									redirectUrl={`/registrations`}
									warningMessage={t('All data related to this registration will be deleted!')}
									successMessage={t('Registration deleted successfully!')}
									failureMessage={t('Unable to delete registration!')}
									handleModal={handleDeletionModal}
									onClose={() => setIsDeletionVisible(false)}
								/>
							</Modal>
						</Box>
					</PageContentWrapper>
				</form>
			</FormikProvider>
		);
	};
	
	// export default Form
	export default withPermissionHOC(Form, [access_registrations])